// src/mixins/focusMixin.js
/**
 * Mixin providing a method to focus a DOM element by its ID.
 *
 * @method focusElement
 * @param {string} id - The ID of the element to focus.
 * @description
 * Waits until the next DOM update cycle, then attempts to find the element
 * with the specified ID and focuses it if found.
 */
export default {
  methods: {
    focusElement(id) {
      console.log('focus')
      this.$nextTick(() => {
        const el = document.getElementById(id)
        if (el) el.focus()
      })
    },
  },
}
